import { gql } from '@apollo/client';

export const fetchTransactionAccountForAccountDetailsScreen = gql`
  query fetchTransactionAccountForAccountDetailsScreen($id: ID!) {
    transactionAccount(id: $id) {
      id
      billToParty {
        name
        addressLine1
        addressLine2
        city
        state
        country
        postcode
        taxId
        taxIds {
          id
          label
          taxExempt
        }
        taxLabels {
          taxIdLabels {
            displayName
            type
          }
        }
        taxExempt
      }
      billToPartyPricingEligibilty
    }
  }
`;
